module.exports = "/assets/data/bcebcb5561c0663b203e415fc93daa90-CV23.data.json";